// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1mkPi","name":"styles_name__1Msmn","phone":"styles_phone__A6aCP"};